import Vue from 'vue'
import App from './App.vue'
import router from './router';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import store from './store';
import VueScrollTo from 'vue-scrollto'
import moment from "moment";
import BackToTop from 'vue-backtotop'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import 'currency-flags/dist/currency-flags.css';
import VuePlaceAutocomplete from 'vue-place-autocomplete';
import i18n from './i18n'

Vue.config.productionTip = false
Vue.filter("formatDate", function(value) {
  if (value) {
    var t = moment(value).subtract(7, "hour");
    return t.format("DD/MM/YYYY เวลา HH:mm น.");
  }else{
    return ''
  }
});
Vue.use(Buefy);
Vue.use(BackToTop)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1,
  easing: 'ease',
  offset: -50,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(VuePlaceAutocomplete)
  
Vue.filter('comma', (value) => {
  if (value != undefined) {
    value = value.toString();
    return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
});
Vue.filter('floatNumber', (number) => {
  if(number != null){
  let result = number.toFixed(1)
    if (Number.isInteger(number)) {
      result = number.toFixed(1)
    }
    return result
  }else{
    return 0
  }
});
Vue.filter('snippet', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 75) {
      return value;
    }
    return `${value.slice(0, 75)}...`;
  }
});
Vue.filter('snippetmoreMid', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 70) {
      return value;
    }
    return `${value.slice(0, 70)}...`;
  }
});

Vue.filter('snippetMid', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 65) {
      return value;
    }
    return `${value.slice(0, 65)}...`;
  }
});
Vue.filter('snippetmoreSmall', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 60) {
      return value;
    }
    return `${value.slice(0,60)}...`;
  }
});
Vue.filter('snippetSmall', (value) => {
  if (value != undefined) {
    const char = value.length;
    if (char <= 50) {
      return value;
    }
    return `${value.slice(0, 50)}...`;
  }
});

new Vue({
  i18n,
  store,
  router,
  render: h => h(App),
}).$mount('#app')
